import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon, Typography } from 'ck-ui';
import { getStoreLocation } from 'ck-utils';
import { Label } from '../utils';
import {
  PriceFacet,
  CategoryFacet,
  CheckboxListFacet,
  ToggleFacet,
} from '../facets';
import { ProductListingPageContext } from '../context';
// import { sortSizes } from '../facets/sizeSort';
import { MyFilter } from './MyFilter';
import { ClearRefinements } from './ClearRefinements';
import styles from './Aside.module.scss';

// const getExtraFilters = (extraFacets) => {
//   let extraFilters = extraFacets || [];
//   const path = window.location.pathname;
//
//   // Extract the query parameter from the URL
//   const query = getQueryParameter();
//
//   const topsKeywords = window.Shopify?.topsExtraFilterKeywords?.split(',') || [];
//   const bottomsKeywords = window.Shopify?.bottomsExtraFilterKeywords?.split(',') || [];
//
//   if (path.includes('tops') || (query && topsKeywords.some(keyword => query?.includes(keyword)))) {
//     extraFilters = Array.from(new Set([...extraFilters, ...(window.Shopify?.topsExtraFilters?.split(',') || [])]));
//   }
//
//   if (path.includes('bottoms') || (query && bottomsKeywords.some(keyword => query?.includes(keyword)))) {
//     extraFilters = Array.from(new Set([...extraFilters, ...(window.Shopify?.bottomsExtraFilters?.split(',') || [])]));
//   }
//   return extraFilters;
// };
const Aside = ({ isMobileOpen, toggleMobileAside, mobileSortBy }) => {
  const { isMobile, extraFacets } = useContext(ProductListingPageContext);
  // const extraFilters = getExtraFilters(extraFacets);
  return (
    <aside
      className={classnames(styles.main, {
        [styles.isMobile]: isMobile,
        [styles.isMobileOpen]: isMobileOpen
      })}
    >
      {isMobile && (
        <a href="#" className={styles.filterClose} onClick={toggleMobileAside}>
          <Typography display="inline" color="black-bis" variant="body-medium" className={styles.filterCloseText}> Close</Typography>
          <Icon name="cross" />
        </a>
      )}
      <div className="card" role="menu">
        {isMobile && (
          <>
            <h2 className={styles.heading2}>Filter By</h2>
            <MyFilter />
          </>
        )}
        {isMobile && mobileSortBy}
        <CategoryFacet />
        {extraFacets?.map(facet => (
          <CheckboxListFacet
            key={facet}
            label={Label.getLocaleString(facet, 'extraFacets')}
            attribute={`extraFacets.${facet}`}
            operator="or"
            limit={50}
          />
        ))}
        {/* <CheckboxListFacet
          label="Sub Categories"
          attribute="subCategory"
          operator="or"
          limit={10}
        /> */}
        <CheckboxListFacet
          label="Gender"
          localeKey="gender"
          attribute="gender"
          operator="or"
          limit={10}
        />
        <CheckboxListFacet
          label="Brand"
          attribute="vendor"
          operator="or"
          limit={200}
          hasFacetSearch
        />
        {window.location.pathname.includes('womens') ? (
          <>
            <CheckboxListFacet
              label="Women's Size"
              attribute="sizesWithGender.womens"
              operator="or"
              limit={200}
              hasFacetSearch
            />
            <CheckboxListFacet
              label="Men's Size"
              attribute="sizesWithGender.dualFromMens"
              operator="or"
              limit={200}
              hasFacetSearch
            />
          </>
        ) : (
          <CheckboxListFacet
            label="Size"
            attribute="sizes"
            operator="or"
            limit={200}
            hasFacetSearch
          />
        )}
        <CheckboxListFacet
          label={getStoreLocation() === 'US' ? 'Color' : 'Colour'}
          attribute="colourPrimary"
          operator="or"
          limit={50}
          sort={Label.sort}
          filter={item => item.label !== 'unknown'}
        />
        <CheckboxListFacet
          label="Discount"
          attribute="discountRange"
          operator="or"
          limit={10}
        />
        <CheckboxListFacet
          label="Price Buckets"
          attribute="priceRange"
          operator="or"
          limit={10}
        />
        <PriceFacet />
        <ToggleFacet
          attribute="isOnSale"
          value="true"
          containerLabel="Sale"
          label="On Sale"
        />
      </div>

      {isMobile ? (
        <div className={classnames(styles.footer, { [styles.isMobileOpen]: isMobileOpen })}>
          <ClearRefinements toggleMobileAside={toggleMobileAside} />
        </div>
      ) : null}
    </aside>
  );
};

Aside.propTypes = {
  isMobileOpen: PropTypes.bool,
  toggleMobileAside: PropTypes.func,
  mobileSortBy: PropTypes.node,
};

Aside.defaultProps = {
  isMobileOpen: false,
  toggleMobileAside: null,
  mobileSortBy: null,
};

export { Aside };
